import React from 'react';
import { Link,useNavigate,useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { BarChart3, ChefHat, Users, ClipboardCheck, Truck, Laptop, TrendingUp, Database } from 'lucide-react';
import '../styles/ServicesPage.css';
import { useEffect } from "react";
import digital from '../assets/digisea.jpeg';
import supplychain from '../assets/supply chain2.jpg';
import kitchen1 from '../assets/kitchen1.jpg';
import Technology from '../assets/Technology.jpeg';
import cost from '../assets/costoptimazation.jpg';
import technologypos from '../assets/technologypos.jpg';
import performance from '../assets/performancetracking.jpg';
import hiring from '../assets/hiring.jpg';
import licience from '../assets/Licensing-Compliance.jpg';
import operation from '../assets/operation.webp';
import { Description } from '@radix-ui/react-dialog';
import { ArrowRight } from 'lucide-react';

const ServicesPage = () => {
  const location = useLocation();
  const navigate =useNavigate();
  useEffect(() => {
    if (location.state?.scrollTo) {
      const element = document.getElementById(location.state.scrollTo);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 100);
        // element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  const services = [
  {
    id:"cost-optimisation",
    icon: <BarChart3 size={40} />,
    title: 'Operations & Cost Optimisation',
    images: [cost
      // operation,
      // 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=400&h=300&fit=crop',
        // 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=300&fit=crop',
        // 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=300&fit=crop'
    ],
    description:'Real-time cost tracking, margin analysis',
  },
  {
    id:"kitchen-menu-systems",
    icon: <ChefHat size={40} />,
    title: 'Kitchen & Menu Systems',
    images: [kitchen1
      // 'https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=400&h=300&fit=crop',
        // 'https://images.unsplash.com/photo-1577219491135-ce391730fb2c?w=400&h=300&fit=crop',
        // 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=400&h=300&fit=crop'
      
    ],
    description:'Streamlined kitchen operations and data-driven menu engineering',
  },
  {
    id:"technology-pos",
    icon: <Laptop size={40} />,
    title: 'Technology, POS & Analytics',
    images: [technologypos,
      // 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=300&fit=crop',
        // 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=300&fit=crop',
        // 'https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?w=400&h=300&fit=crop'
    ],
    description:'Integrated technology solutions and analytics platforms that provide actionable insights for better decisions.',
  },
  {
    id:"performance-tracking",
    icon: <Database size={40} />,
    title: 'Performance Tracking',
    images: [performance,
      // 'https://images.unsplash.com/photo-1543286386-713bdd548da4?w=400&h=300&fit=crop',
      // 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=300&fit=crop',
        // 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=300&fit=crop'
    ],
    description:'Comprehensive KPI tracking and performance monitoring systems that keep you informed and in control.',
  },
  {
    id:"hiring-training",
    icon: <Users size={40} />,
    title: 'Hiring & Training Frameworks',
    images: [hiring
      // 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=400&h=300&fit=crop',
      // https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=400&h=300&fit=crop',
      //   'https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=300&fit=crop'
    ],
    description:'Structured hiring processes and comprehensive training programs that build high-performing teams.',
  },
  {
    id:"digital-growth",
    icon: <TrendingUp size={40} />,
    title: 'Digital Brand & Growth',
    images: [digital],
    description:'Strategic digital marketing and brand positioning that drives customer acquisition and retention.',
  },
   {
    id:"licensing-compliance",
      icon: <ClipboardCheck size={40} />,
      title: 'Licensing & Compliance',
      images: [licience
        // 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=400&h=300&fit=crop',
        // 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=400&h=300&fit=crop',
        // 'https://images.unsplash.com/photo-1554224154-26032ffc0d07?w=400&h=300&fit=crop'
      ],
      description:'Complete regulatory compliance management ensuring your business operates within all legal requirements.',
    },
    {
      id:"supply-chain",
      icon: <Truck size={40} />,
      title: 'Supply Chain & Vendor Systems',
      images: [supplychain ,
        // 'https://images.unsplash.com/photo-1566576721346-d4a3b4eaeb55?w=400&h=300&fit=crop',
        // 'https://images.unsplash.com/photo-1578916171728-46686eac8d58?w=400&h=300&fit=crop',
        // 'https://images.unsplash.com/photo-1494412519320-aa613dfb7738?w=400&h=300&fit=crop'
      ],
      description:'Optimized vendor relationships and supply chain management that ensures quality and cost efficiency.',
    },



    { id:"cost-optimisation",
      icon: <BarChart3 size={48} />,
      title: 'Operations & Cost Optimisation',
      description: 'Real-time cost tracking, margin analysis, and operational efficiency systems that give you complete visibility into your business.',
      features: [
        'Daily P&L tracking and analysis',
        'Food cost optimization',
        'Labor efficiency metrics',
        'Waste reduction systems',
        'Inventory management'
      ]
    },
    {id:"kitchen-menu-systems",
      icon: <ChefHat size={48} />,
      title: 'Kitchen & Menu Systems',
      description: 'Streamlined kitchen operations and data-driven menu engineering that maximizes profitability while maintaining quality.',
      features: [
        'Kitchen workflow optimization',
        'Menu engineering & pricing',
        'Recipe standardization',
        'Prep & production planning',
        'Quality control systems'
      ]
    },
    {id:"hiring-training",
      icon: <Users size={48} />,
      title: 'Hiring & Training Frameworks',
      description: 'Structured hiring processes and comprehensive training programs that build high-performing teams.',
      features: [
        'Role-based hiring frameworks',
        'Skill assessment systems',
        'Onboarding programs',
        'Service training modules',
        'Performance tracking'
      ]
    },
    { id:"licensing-compliance",
      icon: <ClipboardCheck size={48} />,
      title: 'Licensing & Compliance',
      description: 'Complete regulatory compliance management ensuring your business operates within all legal requirements.',
      features: [
        'FSSAI licensing support',
        'Health & safety compliance',
        'Labor law adherence',
        'Documentation systems',
        'Regular compliance audits'
      ]
    },
    { id:"supply-chain",
      icon: <Truck size={48} />,
      title: 'Supply Chain & Vendor Systems',
      description: 'Optimized vendor relationships and supply chain management that ensures quality and cost efficiency.',
      features: [
        'Vendor selection & evaluation',
        'Contract negotiation',
        'Quality assurance protocols',
        'Delivery tracking systems',
        'Cost benchmarking'
      ]
    },
    { id:"technology-pos",
      icon: <Laptop size={48} />,
      title: 'Technology, POS & Analytics',
      description: 'Integrated technology solutions and analytics platforms that provide actionable insights for better decisions.',
      features: [
        'POS system implementation',
        'Analytics dashboard setup',
        'Inventory software integration',
        'Customer data management',
        'Reporting automation'
      ]
    },
    { id:"digital-growth",
      icon: <TrendingUp size={48} />,
      title: 'Digital Brand & Growth',
      description: 'Strategic digital marketing and brand positioning that drives customer acquisition and retention.',
      features: [
        'Brand strategy development',
        'Social media management',
        'Online presence optimization',
        'Customer engagement campaigns',
        'Performance marketing'
      ]
    },
    { id:"performance-tracking",
      icon: <Database size={48} />,
      title: 'Performance Tracking',
      description: 'Comprehensive KPI tracking and performance monitoring systems that keep you informed and in control.',
      features: [
        'Custom KPI dashboards',
        'Real-time performance alerts',
        'Comparative analytics',
        'Trend analysis & forecasting',
        'Monthly performance reviews'
      ]
    }
  ];
const detailedServices = services.filter(service => service.features);
  return (
    <div>
      <Navbar />
      
      <section className="services-hero">
        <div className="services-hero-container">
          <h6>End-to-end operating intelligence for food & beverage businesses</h6>
          <h2 >
            Every service exists for one outcome:
              a business that runs without you carrying it.
          </h2>
        {/* </div>
      </section>

    <section className="services">
      <div className="container"> */}

        <div className="grid">

          {/* COLUMN 1 */}
          <div className="card">
            <div className="icon">🛡️</div>
            <p className="tag">PILLAR 01 — PROTECT</p>
            <h3>Stop losing money you don't know you're losing.</h3>
            <p className="desc">
              The foundation of every profitable restaurant is knowing exactly where every rupee goes — and where it shouldn't be going.
            </p>

            <div className="service-list">
  <div
  className="service-item clickable"
  onClick={() => {
    const el = document.getElementById("cost-optimisation");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  }}
>
    <h4>Operations & Cost Optimisation</h4>
    <p>
      You stop being surprised at month-end. Profitability becomes predictable.
    </p>
    <p className="click-here-text"><b>Explore Service →</b></p>
  </div>

  <div
  className="service-item clickable"
  onClick={() => {
    const el = document.getElementById("licensing-compliance");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  }}
>
    <h4>Licensing & Compliance</h4>
    <p>
      You never face a surprise closure or penalty. Ever.
    </p>
    <p className="click-here-text"><b>Explore Service →</b></p>
  </div>

  <div
  className="service-item clickable"
  onClick={() => {
    const el = document.getElementById("supply-chain");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  }}
>
    <h4>Supply Chain & Vendor Systems</h4>
    <p>
      You stop overpaying vendors and start protecting cost at the source.
    </p>
    <p className="click-here-text"><b>Explore Service →</b></p>
  </div>
</div>

            <div className="highlight">
              <h4>₹3.1L</h4>
              <p>Monthly margin recovered — Deveras Restaurant, South Bengaluru. Food cost 41% → 34.2% in 14 weeks.</p>
            </div>
          </div>

          {/* COLUMN 2 */}
          <div className="card">
            <div className="icon">🕒</div>
            <p className="tag">PILLAR 02 — STABILISE</p>
            <h3>Build a team and operation that holds without you.</h3>
            <p className="desc">
              Most founders are the system. The goal of everything
               we build is to replace you with structure — so your business runs consistently, not just when you're present.
            </p>

            <div className="service-list">
                  <div
  className="service-item clickable"
  onClick={() => {
    const el = document.getElementById("hiring-training");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  }}
>
                    <h4>Hiring & Training Frameworks</h4>
                    <p>
                      Your team performs consistently — even when you're not in the room.
                    </p>
                    <p className="click-here-text"><b>Explore Service →</b></p>
                  </div>

                  <div
  className="service-item clickable"
  onClick={() => {
    const el = document.getElementById("kitchen-menu-systems");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  }}
>
                    <h4>Kitchen & Menu Systems</h4>
                    <p>
                      Your menu earns more — without changing a single dish
                    </p>
                    <p className="click-here-text"><b>Explore Service →</b></p>
                  </div>

                  <div
  className="service-item clickable"
  onClick={() => {
    const el = document.getElementById("technology-pos");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  }}
>
                    <h4>Technology, POS & Analytics</h4>
                    <p>
                      Your data tells you the truth — not what you hope to see.
                    </p>
                    <p className="click-here-text"><b>Explore Service →</b></p>
                  </div>
                </div>

            <div className="highlight">
              <h4>18% → 4%</h4>
              <p>Inventory variance eliminated — Adda's Cloud Kitchen, Whitefield. 3-brand operation systematised in 9 weeks</p>
            </div>
          </div>

          {/* COLUMN 3 */}
          <div className="card">
            <div className="icon">📈</div>
            <p className="tag">PILLAR 03 — GROW</p>
            <h3>Scale without the chaos that breaks most operators.</h3>
            <p className="desc">
              Growth exposes every weakness in an operation. We build the infrastructure that makes expansion deliberate — not dangerous.
            </p>
          

            <div className="service-list">
                  <div
  className="service-item clickable"
  onClick={() => {
    const el = document.getElementById("digital-growth");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  }}
>
                    <h4>Digital Brand & Growth</h4>
                    <p>
                      New customers find you — and existing ones keep coming back.
                    </p>
                    <p className="click-here-text"><b>Explore Service →</b></p>
                  </div>

                  <div
  className="service-item clickable"
  onClick={() => {
    const el = document.getElementById("performance-tracking");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  }}
>
                    <h4>Performance Tracking</h4>
                    <p>
                      Only the signals that actually drive decisions — nothing else.
                    </p>
                    <p className="click-here-text"><b>Explore Service →</b></p>
                  </div>

                  <div
  className="service-item clickable"
  onClick={() => {
    const el = document.getElementById("digital-growth");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  }}
>
                    <h4>Growth Infrastructure</h4>
                    <p>
                      You open a second location without breaking what already works.
                    </p>
                    <p className="click-here-text"><b>Explore Service →</b></p>
                  </div>
                </div>

            <div className="highlight">
              <h4>4 → 1</h4>
              <p>Four operating systems unified — Daily Sushis. All 4 locations identical. Expansion to 8 confirmed</p>
            </div>
          </div>

        </div>
      </div>
    </section>
      <section className="services-overview-section">
  <div className="service-grid">
    {services
  .filter(service => service.images)
  .map((service, index) => (
      // <div key={index} className="service-card">
      <div
          key={index}
          className="services-card"
          onClick={() => {
            if (service.id) {
              const element = document.getElementById(service.id);
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              }
            }
          }}
          style={{ cursor: service.id ? "pointer" : "default" }}
        >

        <div className="service-images">
          {service.images?.map((img, idx) => (
            <div key={idx} className="service-image">
              <img src={img} alt={service.title} loading="lazy" />
            </div>
            
          ))}
          {/* <a href="/operationals-diagnostic" className="btn-primary">
            click here to Explore
            <ArrowRight size={20} />
          </a> */}
        </div>

        <div className="service-content">
          <div className="service-icon">{service.icon}</div>
          <h3>{service.title}</h3>
          <p className="service-description">
  {service.description}
</p>

{service.id && (
  <span
    className="click-here-text"
    onClick={() => {
      const element = document.getElementById(service.id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }}
  >
    Explore Service →
  </span>
)}
        </div>

      </div>
    ))}
  </div>
</section>
      <section id="cost-optimisation" className="service-section"></section>
      <section className="services-detail-section">
        <div className="services-detail-container">
          {/* {services.map((service, index) => (
            <div key={index} className={`service-detail-card ${index % 2 === 1 ? 'reverse' : ''}`}> */}
          {detailedServices.map((service, index) => (
          <div
        key={index}
              id={service.id}
          className={`service-detail-card ${index % 2 === 1 ? 'reverse' : ''}`}
          >

              <div className="service-detail-icon">
                {service.icon}
              </div>
              <div className="service-detail-content">
                <h2>{service.title}</h2>
                <p className="service-description">{service.description}</p>
                <ul className="service-features">
                  {service.features?.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
        {/* <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-images">
                {service.images.map((img, idx) => (
                  <div key={idx} className="service-image">
                    <img src={img} alt={service.title} loading="lazy" />
                  </div>
                ))}
              </div> */}
              {/* <div className="service-content">
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                {service.description && (
                  <p className="service-description">{service.description}</p>
                )}
              </div>
            </div>
          ))}
        </div> */}
        
      </section>

      <section className="services-cta-section">
        <div className="services-cta-container">
          <h2>Ready to Transform Your Operations?</h2>
          <p>Let's discuss how our services can help your business grow profitably.</p>
          {/* <a href="/#contact" className="services-cta-button"> */}
          {/* <button
            className="cta-button"
            onClick={() => navigate("/", { state: { scrollTo: "contact" } })}
          >
          Book a Discovery Call
          </button> */}
          <Link to="/contact" className="btn-2">
              Book a Fit Call
            </Link>
          {/* </a> */}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ServicesPage;